module.exports = __webpack_public_path__ + "img/hair_color_grayHaired.ded5994.svg";